import AgreementPage from "../pages/AgreementPage/AgreementPage";
import AlarmPage from "../pages/alarm/AlarmPage";
import LoginPage from "../pages/auth/LoginPage";
import SignUpPage from "../pages/auth/SignUpPage";
import CmpMainPages from "../pages/CmpPages/CmpMainPages";
import CmpAgreementPage from "../pages/CmpPages/CmpPagesContent/CmpAgreementPage";
import CmpBusinessInfoPage from "../pages/CmpPages/CmpPagesContent/CmpBusinessInfoPage";
import CmpCargoInfoPage from "../pages/CmpPages/CmpPagesContent/CmpCargoInfoPage";
import CmpCarInfoPage from "../pages/CmpPages/CmpPagesContent/CmpCarInfoPage";
import CmpCarManagementInfoPage from "../pages/CmpPages/CmpPagesContent/CmpCarManagementInfoPage";
import CmpDriverInfoPage from "../pages/CmpPages/CmpPagesContent/CmpDriverInfoPage";
import { CmpFinishPage } from "../pages/CmpPages/CmpPagesContent/CmpFinishPage";
import { CmpSignPages } from "../pages/CmpPages/CmpPagesContent/CmpSignPage";
import CompletedMatchListDetailPage from "../pages/CompletedMatchListDetailPage/CompletedMatchListDetailPage";
import HomePage from "../pages/HomePage";
import MatchListPage from "../pages/MatchList/MatchList";
import MatchList from "../pages/MatchList/MatchList";
import MatchListDetailPage from "../pages/MatchListDetail/MatchListDetail";
import MorePage from "../pages/More/MorePage";
import MyDriveListPage from "../pages/MyDriveListPage/MyDriveListPage";
import MyDrivePage from "../pages/MyDrivePage/MyDrivePage";
import NotificationEventPage from "../pages/NotificationEvent/NotificationEventPage";
import PendingPage from "../pages/PendingPage/PendingPage";
import PersonalInformationProcessingPolicyPage from "../pages/PersonalInformationProcessingPolicy/PersonalInformationProcessingPolicyPage";
import TaskDetailMainPage from "../pages/TaskDetailPages/TaskChargeTransfer";
import TaskImgUploadPage from "../pages/TaskDetailPages/TaskImgUpload/TaskImgUploadPage";
import WithdrawalPage from "../pages/WithdrawalPage/WithdrawalPage";
import { Routes as DomReroutes, Navigate, Route } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userState } from "../states/user";
import UserAccountFindPage from "../pages/UserAccountFindPage/UserAccountFindPage";
import CmpCarRegistInfoPage from "../pages/CmpPages/CmpPagesContent/CmpCarRegistInfoPage";
import CmpCargoInsurInfoPage from "../pages/CmpPages/CmpPagesContent/CmpCargoInsurInfoPage";
import UserInfoPage from "../pages/UserInfoPages/UserInfoPage";
import UserInfoEditPage from "../pages/UserInfoEditPges/UserInfoEditPage";
import CmpCarInfoChangePage from "../pages/CmpPages/CmpPagesContent/CmpCarInfoChangePage";
import AlarmOptionPage from "../pages/alarm/AlarmOptionPage";
import UserPasswordChangePage from "../pages/UserPasswordChangePage/UserPasswordChangePage";
import NotFoundPage from "../pages/404";
import { PrivateRoute } from "./PrivateRoute";
import TaskInvoiceImgUploadPage from "../pages/TaskDetailPages/TaskInvoiceImgUpload/TaskInvoiceImgUploadPage";

interface RouterItem {
  path: string;
  element: React.ReactNode;
  withAuthorization: boolean;
  pageTitle?: string;
  requireApproval?: boolean;
}

const routerItems: RouterItem[] = [
  /* 메인 홈 */
  {
    path: "/home",
    element: <HomePage />,
    withAuthorization: true,
    requireApproval: true,
  },
  /** 알람 */
  {
    path: "/alarm",
    element: <AlarmPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  /** 약관 */
  {
    path: "/agreement",
    element: <AgreementPage />,
    withAuthorization: true,
  },
  /* 로그인 */
  {
    path: "/sign-in",
    element: <LoginPage />,
    withAuthorization: false,
  },
  // 사용자 계정 찾는 페이지
  {
    path: "/user-account-find",
    element: <UserAccountFindPage />,
    withAuthorization: false,
  },

  /** 회원가입 */
  {
    // 안내사항 페이지
    path: "/cmp-page",
    element: <CmpMainPages />,
    withAuthorization: false,
  },
  {
    path: "/auth/sign-up",
    element: <SignUpPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp",
    element: <CmpMainPages />,
    withAuthorization: false,
  },
  {
    path: "/cmp/agreement-page",
    element: <CmpAgreementPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp/business-info",
    element: <CmpBusinessInfoPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp/car-info",
    element: <CmpCarInfoPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp/car-management-info",
    element: <CmpCarManagementInfoPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp/cargo-page",
    element: <CmpCargoInfoPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp/driver-info",
    element: <CmpDriverInfoPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp/finish-page",
    element: <CmpFinishPage />,
    withAuthorization: false,
  },
  {
    path: "/cmp/sign-page",
    element: <CmpSignPages />,
    withAuthorization: false,
  },
  {
    path: "/completed-match-list-detail",
    element: <CompletedMatchListDetailPage />,
    withAuthorization: false,
  },
  {
    path: "/match-list",
    element: <MatchListPage />,
    withAuthorization: false,
  },
  {
    path: "/match-list-detail",
    element: <MatchListDetailPage />,
    withAuthorization: false,
  },
  {
    path: "/more",
    element: <MorePage />,
    withAuthorization: false,
  },
  {
    path: "/my-drive-list",
    element: <MyDriveListPage />,
    withAuthorization: false,
  },
  {
    path: "/my-drive",
    element: <MyDrivePage />,
    withAuthorization: false,
  },
  {
    path: "/notification-event",
    element: <NotificationEventPage />,
    withAuthorization: false,
  },
  {
    path: "/pending",
    element: <PendingPage />,
    withAuthorization: true,
    requireApproval: false,
  },
  {
    path: "/personal-information-processing-policy",
    element: <PersonalInformationProcessingPolicyPage />,
    withAuthorization: false,
  },
  {
    path: "/task-detail",
    element: <TaskDetailMainPage />,
    withAuthorization: false,
  },
  {
    path: "/task-img-upload",
    element: <TaskImgUploadPage />,
    withAuthorization: false,
  },
  {
    path: "/withdrawal",
    element: <WithdrawalPage />,
    withAuthorization: false,
  },
  // /* 회원가입 */
  // {
  //   path: "/auth/join/type",
  //   element: <JoinTypePage />,
  //   withAuthorization: false,
  // },
  // {
  //   path: "/auth/join/agree-attend",
  //   element: <AgreeAttendPage />,
  //   withAuthorization: false,
  // },
  {
    path: "/home",
    element: <HomePage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    path: "/sign-in",
    element: <LoginPage />,
    withAuthorization: false,
  },
  {
    // 사용자 계정 찾는 페이지
    path: "/user-account-find",
    element: <UserAccountFindPage />,
    withAuthorization: false,
  },
  {
    // 안내사항 페이지
    path: "/cmp-page",
    element: <CmpMainPages />,
    withAuthorization: false,
  },
  {
    // 약관동의 페이지
    path: "/agreement-page",
    element: <CmpAgreementPage />,
    withAuthorization: false,
  },
  {
    // 사용자 정보 가입 페이지
    path: "/sign-up",
    element: <SignUpPage />,
    withAuthorization: false,
  },
  {
    // 차량 정보 입력 페이지
    path: "/cmp-car-page",
    element: <CmpCarInfoPage />,
    withAuthorization: false,
  },
  {
    // 화물 운송사 자격증명 페이지
    path: "/cmp-cargo-page",
    element: <CmpCargoInfoPage />,
    withAuthorization: false,
  },
  {
    // 운전 면허증 등록 페이지
    path: "/cmp-driver-page",
    element: <CmpDriverInfoPage />,
    withAuthorization: false,
  },
  {
    // 사업자 등록증 등록 페이지
    path: "/cmp-business-page",
    element: <CmpBusinessInfoPage />,
    withAuthorization: false,
  },
  {
    // 자동차 등록증 등록 페이지
    path: "/cmp-car-regist-page",
    element: <CmpCarRegistInfoPage />,
    withAuthorization: false,
  },
  {
    // 지입 계약서
    path: "/cmp-sign",
    element: <CmpSignPages />,
    withAuthorization: false,
  },
  {
    // 적재물배상책임보험증서 등록 페이지
    path: "/cmp-cargo-insur-page",
    element: <CmpCargoInsurInfoPage />,
    withAuthorization: false,
  },
  {
    // 완료 페이지
    path: "/cmp-finish",
    element: <CmpFinishPage />,
    withAuthorization: false,
  },
  {
    // 알림 페이지
    path: "/alarm",
    element: <AlarmPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 운송 매칭 페이지
    path: "/matchlist",
    element: <MatchList />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 운송 매칭 상세 페이지
    path: "/matchListDetail",
    element: <MatchListDetailPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 더보기 페이지
    path: "/more",
    element: <MorePage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 내 운송 현황 페이지
    path: "/task-chargeTransfer",
    element: <TaskDetailMainPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 내 운송 정보 페이지
    path: "/myDrive",
    element: <MyDrivePage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 내 정보 페이지
    path: "/myinfo",
    element: <UserInfoPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 내 정보 수정 페이지
    path: "/myinfo/myinfo-edit",
    element: <UserInfoEditPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 차량 등록 관리 페이지
    path: "/carmanagement",
    element: <CmpCarManagementInfoPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 차량 정보 변경 페이지
    path: "/carinfochange",
    element: <CmpCarInfoChangePage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 사진 등록 페이지
    path: "/imgupload",
    element: <TaskImgUploadPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 인수증 사진 등록 페이지
    path: "/invoice-imgupload",
    element: <TaskInvoiceImgUploadPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 공지 및 이벤트 페이지
    path: "/notificationevent",
    element: <NotificationEventPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 알림 설정 페이지
    path: "/Alarmoption",
    element: <AlarmOptionPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 약관 및 정책 페이지
    path: "/agreement",
    element: <AgreementPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 내 운송 기록 페이지
    path: "/mydrive-list",
    element: <MyDriveListPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 내 운송 기록 - 상세내역 페이지
    path: "/completedMatchListDetail",
    element: <CompletedMatchListDetailPage />,
    withAuthorization: true,
    requireApproval: true,
  },
  {
    // 사용자 비밀번호 발급 페이지
    path: "/user-password-change",
    element: <UserPasswordChangePage />,
    withAuthorization: false,
  },
  {
    path: "/pending",
    element: <PendingPage />,
    withAuthorization: true,
    requireApproval: false,
  },
  // 개인정보 처리 방침 페이지
  {
    path: "/personalInformationProcessingPolicy",
    element: <PersonalInformationProcessingPolicyPage />,
    withAuthorization: false,
  },
  // 회원 탈퇴 요청 페이지
  {
    path: "/withdrawal",
    element: <WithdrawalPage />,
    withAuthorization: false,
  },
  {
    path: "(.*)",
    element: <NotFoundPage />,
    withAuthorization: false,
  },
];

export function Routes() {
  return (
    <DomReroutes>
      <Route path="/" element={<PrivateRoute />} />

      {routerItems
        .filter((route) => route.withAuthorization)
        .map((route: RouterItem) => {
          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}

      {routerItems
        .filter((route) => !route.withAuthorization)
        .map((route: RouterItem) => {
          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}
    </DomReroutes>
  );
}
